import AttachmentAPI from '../../api/attachments';

const state = {
  selectedRows: [],
  selectedRowsInPage: {},
  selectAllStorage: false,
  loading: false,
  meta: {},
  sortConfig: {
    byte_size: 'desc',
  },
  attachments: [],
  uiFlags: {
    isDeleting: false,
  },
};

export const getters = {
  getSelectedRows($state) {
    return $state.selectedRows;
  },
  getSelectedRowsInPage($state) {
    return $state.selectedRowsInPage;
  },
  getLoading($state) {
    return $state.loading;
  },
  getMeta($state) {
    return $state.meta;
  },
  getAttachments($state) {
    return $state.attachments;
  },
  isSelectAllStorage($state) {
    return $state.selectAllStorage;
  },
  getSortConfig($state) {
    return $state.sortConfig;
  },
  getSortAttribute($state) {
    return Object.keys($state.sortConfig).reduce((acc, sortKey) => {
      const sortOrder = $state.sortConfig[sortKey];
      if (sortOrder) {
        const sortOrderSign = sortOrder === 'asc' ? '' : '-';
        return `${sortOrderSign}${sortKey}`;
      }
      return acc;
    }, '');
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async fetchRecords({ commit, getters: { getSortAttribute } }, { page } = {}) {
    commit('SET_LOADING', true);
    try {
      const {
        data: { attachments, meta },
      } = await AttachmentAPI.get({
        page: page || 1,
        sort: getSortAttribute,
      });
      commit('SET_RESPONSE', {
        attachments,
        meta,
      });
    } catch (e) {
      console.log(e);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async deleteAttachments({
    state: { selectedRows, selectAllStorage },
    commit,
    dispatch,
  }) {
    if (!selectAllStorage && !selectedRows.length) return;

    if (selectAllStorage) {
      await AttachmentAPI.batchDestroyAll();
    } else {
      await AttachmentAPI.batchDestroy(selectedRows);
    }
    commit('RESET_SELECTED_ROWS');
    commit('SET_UI_FLAG', {
      isDeleting: false,
    });
    dispatch('fetchRecords');
  },
};

export const mutations = {
  SET_SELECTED_ROWS($state, data) {
    $state.selectedRowsInPage = {
      ...$state.selectedRowsInPage,
      [data.page]: data.selectedRowKeys,
    };
    $state.selectedRows = Object.values($state.selectedRowsInPage).flat();
  },
  RESET_SELECTED_ROWS($state) {
    $state.selectedRows = [];
    $state.selectedRowsInPage = {};
    $state.selectAllStorage = false;
  },
  SET_SELECT_ALL_STORAGE($state, value) {
    $state.selectAllStorage = value;
    if (!value) {
      $state.selectedRows = [];
      $state.selectedRowsInPage = {};
    }
  },
  SET_RESPONSE($state, { meta, attachments }) {
    $state.meta = meta;
    $state.attachments = attachments;
  },
  SET_SORT_CONFIG($state, value) {
    $state.sortConfig = value;
  },
  SET_LOADING($state, value) {
    $state.loading = value;
  },
  SET_UI_FLAG($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
